import axios from "axios";
const https = require('https');

var browser = {
    versions: function() {
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

// function downloadUrl(_downloadType, _downloadName) {
//     let params = { downloadType: _downloadType, downloadName: _downloadName };
//     downloadInfo(params);
// }

function downloadUrl( _downloadType, _downloadName, _downloadFileName ) {
    let params = { downloadType: _downloadType, downloadName: _downloadName, downloadFileName: _downloadFileName };
    downloadInfo(params);
}

function downloadInfo(params) {
    return new Promise((resolve, reject) => {
        axios.get("https://www.tac.com.tw/JsonFile/" + params.downloadName, {
            params: params,
            responseType: "blob" // 1.首先設置responseType對象格式為 blob: 
        }).then(res => {
                if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                    let blob = new Blob([new Uint8Array(res.data)], {
                        type: "octet/stream"
                    });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        if(params.downloadFileName !== undefined ){
                            window.navigator.msSaveOrOpenBlob(blob, params.downloadFileName);
                        } else {
                            window.navigator.msSaveOrOpenBlob(blob, params.downloadName);
                            // window.open(window.navigator.msSaveOrOpenBlob(blob, params.downloadName));
                        }
                        
                    }
                } else {
                    // let blob = new Blob([res.data], { type: params.downloadType });
                    // var reader = new FileReader();
                    // var newWindow = null; 
                    // reader.onload = function(e) {
                    //     var bdata = btoa(reader.result);
                    //     var datauri = 'data:' + params.downloadType + ';base64,' + bdata;
                    //     downloadURI(datauri, params.downloadFileName, params.downloadName )
                    // };
                    // reader.readAsBinaryString(blob);


                    // resolve(res) 
                    let blob = new Blob([res.data], { type: params.downloadType });
                    // 2.獲取請求返回的response對象中的blob 設置文件類型，這裡以excel為例 
                    let url = window.URL.createObjectURL(blob);
                    // 3.創建一個臨時的url指向blob對象 
                    // 4.創建url之後可以模擬對此文件對象的一系列操作，例如：預覽、下載 
                    let a = document.createElement("a");
                    a.href = url;
                    if(params.downloadFileName !== undefined){
                        a.download = params.downloadFileName;
                    } else {
                        a.download = params.downloadName;
                    }
                    a.click();
                    // 5.釋放這個臨時的對象url 
                    window.URL.revokeObjectURL(url);
                }

            },
            err => { resolve(err.response); }).catch(error => { reject(error); });
    });
}

function getApi(url, params) {
    const agent = new https.Agent({
        rejectUnauthorized: false
    });
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params, httpsAgent: agent, withCredentials: false }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
            console.log(err.data)
        })
    });
}

function postApi(url, json) {
    return new Promise((resolve, reject) => {
        axios.post(url, json, { headers: { 'Content-Type': 'application/json' } }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
            console.log(err.data)
        })
    });
}

function downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default { // Js回傳功能用很關鍵
    downloadUrl,
    getApi,
    postApi
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js